import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Countdown from "react-countdown";
import { base_url } from "../../Api/Api";
import PulseLoader from "react-spinners/PulseLoader";

const LotteryItem = (props) => {
  console.log(props.error);
  const [state, setState] = useState({
    data: props.data, // api data
    timeStyle: false, // color background timer
    days: 0,
    hours: 0,
    minutes: 0,
    canRegister: props.data.can_register,
    images: props.data.images,
    completed: false,
  });
  const [loader, setLoader] = useState(false);

  const Days = useRef(0);
  const Hours = useRef(0);
  const Minutes = useRef(0);

  // Renderer callback with condition
  const timerRender = ({ days, hours, minutes, completed }) => {
    if (
      Days.current.innerText != undefined &&
      Hours.current.innerText != undefined &&
      Minutes.current.innerText != undefined
    ) {
      Days.current.innerText = days;
      Hours.current.innerText = hours == 0 ? "00" : hours;
      Minutes.current.innerText = minutes == 0 ? "00" : minutes;
    }
    if (completed) {
      return (
        <>
          <span>00</span>
          <span>00</span>
          <span>0</span>
        </>
      );
    } else {
      // Render a countdown
      return (
        <span>
          {days}:{hours}:{minutes}
        </span>
      );
    }
  };

  const lotteryRegister = () => {
    props.showCountPopup(true);
    props.requiredScore(state.data.required_score);
    localStorage.setItem("lotteryId", state.data.id);
  };

  // const lottery = () =>{
  //   props.showCountPopup(false)
  //   // setState({...state, countPopupStatus: false })
  //   setLoader(true)
  //   const Data = {
  //     'lottery_id': localStorage.getItem.lotteryId,
  //     count: state.count,
  // };
  // const headers = {
  //     "Authorization": cookies.get("api_key"),
  //     "content-type": "application/json",
  // };
  // base_url.post("lottery_register", Data, {
  //
  // })
  //     .then(response => {
  //         if (response.data.status) {
  //             setState({
  //                 ...state,
  //                 canRegister: false
  //             })
  //         }
  //         setLoader(false)
  //         props.showPopup(true)
  //     })
  //     .catch(error => {
  //         if (error.response != undefined) {
  //             if (error.response.status == 401) {
  //                 props.history.push(`/Entrance`)
  //             }
  //             setLoader(false)
  //         }
  //     })
  // }
  console.log(state.data.id);
  return (
    <div
      className={`ballotItem ${
        state.data.length == 0
          ? ""
          : state.data.time_secound <= 0
          ? "expire"
          : ""
      }`}
    >
      <div className="lotteryIcon">
        <img src="/svg/present.svg" />
      </div>
      <div className="lot">
        <h6 className="title">{state.data == null ? "" : state.data.title}</h6>
        <div className="counter">
          <div className="imgesBall">
            <img src={`${state.data.image}`} />
          </div>
          {/* {state.data == null ? '' : state.data.register_count == 0 ?
                        <span>شما در این قرعه کشی شرکت نکرده اید</span>
                        :
                        <span>تعداد دفعات شرکت در این قرعه کشی: {state.data.register_count}</span>
                    } */}

          <span>زمان باقی مانده تا قرعه کشی</span>
          {state.data.time_secound <= 0 ? (
            <div className="btn-expire">
              <Button variant="contained">قرعه کشی به پایان رسیده</Button>
            </div>
          ) : (
            <div className="timestamp">
              <div className="time">
                <span ref={Minutes}>{state.minutes}</span>
                <span>دقیقه</span>
              </div>
              <div className="time">
                <span ref={Hours}>{state.hours}</span>
                <span>ساعت</span>
              </div>
              <div className="time">
                <span ref={Days}>{state.days}</span>
                <span>روز</span>
              </div>
              <div className="cmpnt-timer">
                {state.data == null ? null : (
                  <Countdown
                    date={Date.now() + state.data.time_secound * 1000}
                    renderer={timerRender}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="lotDetail">
        <div className="grades">
          <span>
            حداقل امتیاز :{" "}
            <b>{state.data == null ? "" : state.data.required_score}</b>
          </span>
          <span>
            امتیاز شما :{" "}
            <b>{state.data == null ? "" : state.data.user_score}</b>
          </span>
        </div>
        <span
          style={{
            margin: "1rem",
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
            color: "red",
          }}
          className={`error-respns ${
            props.error.id === state.data.id ? "active" : ""
          }`}
        >
          {props.error.message}
        </span>
        <div className="btn-base btn-black btn-sircle">
          {state.data == null ? (
            0
          ) : state.data.can_register ? (
            <Button variant="contained" onClick={() => lotteryRegister()}>
              {loader ? (
                <PulseLoader color="#fff" size={10} />
              ) : (
                "شرکت در قرعه کشی"
              )}
            </Button>
          ) : (
            <div className="btn-expire Lottery-btn-ex">
              <Button
                disabled={state.required_score > state.data.user_score}
                variant="contained"
              >
                شرکت در قرعه کشی
              </Button>
            </div>
          )}
        </div>
        <Link
          to={`${
            state.data == null
              ? 0
              : state.data.status === 0
              ? "/Lottery/LotteryExpire"
              : "/Lottery/LotteryDetail"
          }/${state.data == null ? 0 : state.data.id}`}
        >
          جزییات بیشتر
        </Link>
      </div>
    </div>
  );
};

export default LotteryItem;
